export default {
	languageTxt: 'vi_VN',
	operationBox: {
	    dropdownName: 'Chức năng khác',         // 其他（原：Chức năng khác）
	    offOn: 'Bật/Tắt',            // 开关（原：Bật/tắt đèn）
	    brightness2: 'Điều chỉnh độ sáng',       // 亮度 / 调光（原：Điều chỉnh độ sáng）
	    changelnglat: 'Điều chỉnh vị trí',       // 坐标 / 位置（原：Điều chỉnh vị trí）
	    changelnglat2: 'Chỉnh tay',   // 手动调整（原：Điều chỉnh thủ công）
	    loopControl: 'Mạch điều khiển'      // 回路控制（原：Điều khiển mạch）
	},
	setNumAbbrFun: {
		hundred: 'Trăm',
		thousand: 'Nghìn',
		tenthousand: 'Vạn',
		Lakh: 'Trăm nghìn',
		million: 'Triệu',
		tenmillion: 'Chục triệu'
	},
	unit: {
		pcs: 'Chiếc',
		pcs2: 'Cái'
	},
	cron: {
		expressionParseError: "Lỗi phân tích cú pháp biểu thức"
	},
	citySplit: 'Tỉnh',
	all: 'Tất cả',
	magStyle: {
		right: 'Nền trắng gốc',
		black: 'Giao diện tối'
	},
	tgEver: {
		timeEver: "Thời gian vĩnh viễn",
		timeNoEver: 'Hủy vĩnh viễn',
		timeEverPlaceholder: 'Thời gian vĩnh viễn',
		timeNoEverPlaceholder: 'Chọn ngày giờ'
	},
	// SystemName: 'Hệ thống chiếu sáng điều khiển thông minh Hechuang',
	SystemName: 'Hệ thống chiếu sáng thông minh',
	userLogin: "Đăng nhập người dùng",
	logOut: 'Đăng xuất',
	SecretKey: 'Xác thực SecretKey',
	goToIndex: 'Về trang chủ',
	
	tag: {
		onLine: "Trực tuyến",
		offLine: "Ngoại tuyến",
		success: "thành công",
		fail: "thất bại",
		normal: "Bình thường",
		cancel: "Khóa tài khoản",
		emergency: "Khẩn cấp",
		ceneral: "Thông thường",
		updata: 'Đang nâng cấp',
		failUpdata: 'Lỗi nâng cấp‌',
		serious: 'Cảnh báo nghiêm trọng',
		major: 'Cảnh báo mức độ vừa',
		normalWarn: 'Cảnh báo thông thường',
		eliminated: 'Đã hủy',
		notEliminated: 'Chưa hủy',
		ignore: 'Bỏ qua',
		transformWork: 'Chuyển sang phiếu công việc',
		open: "Bật",
		close: 'Tắt',
		enable: 'Kích hoạt',
		disable: 'Dừng',
		disable1: 'Vô hiệu hóa',
		runOnce: 'Chạy một lần',
	},
	tableColumn: {
		index: 'STT',
		id: 'id',
		devicesName: 'Tên',
		MountChannelNumber: 'Số kênh gắn kèm',
		RegistrationResults: 'Kết quả đăng ký',
		devicesName2: 'Tên thiết bị',
		productName: 'Tên sản phẩm',
		categoryName: 'Tên phân loại',
		devicesRegisterTime: 'Thời gian đăng ký thiết bị',
		updateTime: 'Thời gian cập nhật',
		createTime: 'Thời gian tạo',
		devicesId: 'Mã thiết bị',
		onlineStatus: 'Trạng thái',
		hkIp: 'Cổng IP (Tên miền)',
		account: "Tài khoản",
		name: 'Tên',
		pwd: 'Mật khẩu',
		hkJwd: 'Kinh vĩ độ',
		nvr: "NVR gắn kèm",
		hkChannel: "Số kênh",
		rt: 'Thời gian hoạt động',
		wv: 'Điện áp',
		i: 'Dòng điện',
		z: 'Chính',
		f: 'Phụ',
		p: 'Công suất',
		e: 'Điện năng',
		l: 'Độ sáng',
		s: 'Nhiệt độ màu',
		time: 'Thời lượng',
		hardWare: 'Phiên bản phần cứng',
		softWare: 'Phiên bản phần mềm',
		tmDate: 'Đồng hồ thiết bị',
		hsipp: 'Thông số mạng',
		hs: 'Thời gian heartbeat',
		ipp: 'ipp',
		wlid: 'ID mạng',
		message: 'Kết quả thực thi',
		powerOnTime: 'Thời gian cấp điện thiết bị',
		fs: 'Nhiệt độ màu đèn phụ',
		zs: 'Nhiệt độ màu đèn chính',
		fl: 'Độ sáng đèn phụ',
		zl: 'Độ sáng đèn chính',
		fe: 'Điện năng đèn phụ',
		ze: 'Điện năng đèn chính',
		fp: 'Công suất đèn phụ',
		zp: 'Công suất đèn chính',
		fi: 'Dòng điện đèn phụ',
		zi: 'Dòng điện đèn chính',
		rs: 'RSSI',
		tp: 'Nhiệt độ',
		ld: 'Độ sáng liên kết',
		keepTime: 'Thời gian trễ (phút)',
		times: 'Thời gian',
		keepTime: 'Thời gian duy trì (phút)',
		enable: 'Kích hoạt',
		aboTimes: 'Dấu thời gian tuyệt đối',
		nickname: 'Biệt danh người dùng',
		username: 'Tên người dùng',
		operation: 'Thao tác',
		sxdy: 'Điện áp 3 pha',
		sxdl: 'Dòng điện 3 pha',
		sxgl: 'Công suất 3 pha',
		sxdn: 'Điện năng 3 pha',
		longitude: 'Kinh độ',
		latitude: 'Vĩ độ',
		assetName: 'Tên cột đèn',
		mountDevicesId: 'Thiết bị gắn kèm',
		lightType: 'Loại chiếu sáng',
		sumEnergy: 'Năng lượng tiêu thụ',
		group: 'Mã nhóm thiết bị',
		lkg: "Công tắc vận hành",
		moveTarget: "Mục tiêu chuyển động",
		dc: "Khả năng phát hiện",
		rai: "Khả năng chống nhiễu",
		radarConfig: "Cấu hình Radar",
		aic: "Cấu hình thị giác AI",
		pgn: 'Lên',
		tgn: 'Xuống',
		ras: 'Độ nhạy',
		rcd: 'Hướng dò',
		riar: 'Bù góc',
		rai: 'Chống nhiễu',
		rtd1: 'Khoảng cách1',
		rtd2: 'Khoảng cách2',
		rtd3: 'Khoảng cách3',
		rts1: 'Độ nhạy1',
		rts2: 'Độ nhạy2',
		rts3: 'Độ nhạy3',
	},
	request: {
		AlarmInfoOperationData: {
			0: 'Thiết bị',
			1: 'Không có kinh vĩ độ'
		},
		limitSize: 'Kích thước dữ liệu yêu cầu vượt quá giới hạn 5MB cho phép, không thể xác minh chống gửi lặp lại.',
		intervalError: 'Dữ liệu đang được xử lý, vui lòng không gửi lặp lại',
		download: {
			Loading: 'Dữ liệu đang tải xuống, vui lòng đợi',
			zipError: 'Đã xảy ra lỗi khi tải tệp xuống, vui lòng liên hệ quản trị viên!'
		},
		errorCode401Fun: {
			content: 'Phiên đăng nhập đã hết hạn, bạn có thể tiếp tục ở lại trang này hoặc đăng nhập lại',
			confirmButtonText: 'Đăng nhập lại',
			passwordError: 'Tên đăng nhập hoặc mật khẩu không đúng, vui lòng đăng nhập lại.',
			NetworkError: 'Kết nối API bất thường',
			timeout: 'Yêu cầu API hệ thống hết thời gian chờ',
			RequestErrorbefore:  'API hệ thống',
			RequestErrorafter: 'Bất thường',
		},
	},
	FormC: {
		edit: 'Chỉnh sửa',
		add: 'Tạo mới',
		noData: 'Không có dữ liệu',
		dellMore: 'Xóa hàng loạt',
		search: 'Tìm kiếm',
		reset: 'Đặt lại',
		ElMessageBox: {
			tips: 'Thông báo hệ thống',
			titleEnd: ' không?',
			disableTip: 'Bạn có chắc chắn muốn vô hiệu hóa không?',
			enableTip: 'Bạn có chắc chắn muốn kích hoạt không?',
			oneRunTip: 'Bạn có chắc chắn muốn chạy một lần không?',
			offTip: 'Bạn có chắc chắn muốn dừng không?',
			cancelTip: 'Bạn có chắc chắn muốn hủy chiến lược không?',
			isModeTip: 'Bạn có chắc chắn muốn thực thi kịch bản không?',
			title: 'Bạn có chắc chắn muốn xóa không?',
			title2: 'Bạn có chắc chắn muốn xóa hàng loạt không?',
			title3: 'Vui lòng chọn dữ liệu cần xóa hàng loạt',
			title4: 'Vui lòng chọn Tỉnh/Thành phố/Quận/Huyện',
			title5: 'Người dùng cấp cao không thể truy cập trang này, nhấn Xác nhận để quay lại trang quản lý người dùng',
			title6: 'Bạn có chắc chắn muốn xóa toàn bộ nhật ký không?',
			title7: 'Bạn có chắc chắn muốn khởi động lại không?',
			title8: 'Bạn có chắc chắn muốn đặt lại không?',
			title9: 'Vui lòng chọn dữ liệu cần xử lý',
			title10: 'Số lượng cảnh báo không được vượt quá 20',
			titleUser: 'Vui lòng chọn người dùng trước khi thao tác',
			titleExport: 'Vui lòng chọn dữ liệu cần xuất',
			titleSearch: 'Vui lòng nhập từ khóa trước khi tìm kiếm',
			error: 'Xóa thất bại, vui lòng liên hệ quản trị viên.',
			repeated: "Yêu cầu đang được xử lý, vui lòng không gửi lặp lại!",
		},
		schedule:"Vui lòng chọn lịch sửa đổi hàng loạt",
		avatarUploader: {
			loading: 'Đang tải lên...',
			title: 'Biểu tượng ứng dụng',
			title2: 'Vui lòng nhấn để tải lên',
			text: 'Chỉ hỗ trợ hình ảnh có dung lượng dưới 2MB',
			error: 'Hình ảnh tải lên không được vượt quá 2MB!'
		},
		del: 'Xóa',
		Close: 'Đóng',
		cancel: 'Hủy',
		cancel2: 'Đã hủy',
		operation: 'Thao tác',
		operation2: 'Điều khiển nhóm',
		confirm: 'Xác nhận',
		confirm2: 'Xác nhận',
		sort: 'Sắp xếp',
		return: 'Quay lại',
		save: 'Lưu',
		runOnce: 'Chạy một lần',
		placeholder: 'Vui lòng chọn',
		placeholder2: 'Vui lòng chọn thời gian',
		placeholder3: 'Nhập mã sản phẩm để tìm kiếm',
		placeholder4: 'Vui lòng chọn loại thiết bị',
		placeholder5: 'Vui lòng chọn thao tác',
		placeholder6: 'Nhập mã thiết bị để tìm kiếm',
		placeholder7: 'Nhập đối tượng thao tác để tìm kiếm',
		placeholder8: 'Lọc loại thao tác',
		placeholder9: 'Lọc phân loại',
		placeholderMax: 'Vui lòng nhập giá trị tối đa',
		placeholderMin: 'Vui lòng nhập giá trị tối thiểu',
		placeholderInput: 'Vui lòng nhập',
		placeholderUpload: 'Vui lòng tải lên',
		placeholderSelect: 'Vui lòng chọn',
		placeholderTimeZone: 'Lọc múi giờ',
		error: 'Thao tác thất bại',
		success: 'Thao tác thành công',
		success2: 'Điều chỉnh thành công',
		rules: {
			time: 'Vui lòng thiết lập thời lượng',
			size: 'Độ dài tối thiểu là 1, tối đa là 20',
			ip: 'Vui lòng nhập IP. Ví dụ: 127.0.0.1',
			ip2: 'Định dạng IP không hợp lệ, vui lòng nhập lại. Ví dụ: 127.0.0.1'
		},
		inputDefPlaceholder: 'Vui lòng điền',
		Uploader: 'Tải lên tệp:',
		pWorkStatus: "Trạng thái phiếu công việc",
		pWorkName: "Tên phiếu công việc",
	},
	login: {
		left: {
			LampControl: 'Điều khiển đèn',
			DistributionCabinet: 'Tủ phân phối điện',
		},
		form: {
			username: 'Tên đăng nhập:',
			password: 'Mật khẩu:',
			rememberMe: 'Ghi nhớ mật khẩu',
			Login: 'Đăng nhập',
			record: '粤ICP备2021129348号'
		},
		rules: {
			username: 'Vui lòng nhập tên đăng nhập',
			password: 'Vui lòng nhập mật khẩu'
		},
		autoLogin: {
			title: 'Thông báo đăng nhập',
			loginFail: 'Đăng nhập tự động thất bại, vui lòng đăng nhập lại',
			signFail: 'Xác thực chữ ký thất bại, vui lòng lấy lại liên kết đăng nhập',
			confirm: 'Xác nhận'
		}
	},
	index: {
		header: {
			sunrise: 'Bình minh:',
			sunset: 'Hoàng hôn:',
			enterSys: 'Quản trị',
			selectProject: 'Ứng dụng',
			user: 'Quản lý người dùng',
			regShowFun: 'Xem kết quả thao tác',
			regShowBox: 'Kết quả thao tác',
			regShowBoxOptionBox: 'Xem chi tiết',
			json: {
				lightSource: 'Điều khiển đèn',
				lightSource2: 'Nguồn sáng',
				DistributionCabinet: 'Tủ phân phối điện',
				LampPost: 'Cột đèn',
			}
		},
		guangyuanOptionBox: {
			title: 'Bật/tắt đèn hàng loạt',
			label: 'Tên nhóm:'
		},
		deviceInfo: {
			totalName: 'Tổng số thiết bị',
			json: {
				on: 'Bật đèn',
				off: 'Tắt đèn',
				lightOnOffTime: 'Thời gian bật/tắt đèn',
				lightOnRate: 'Biểu đồ xu hướng tỷ lệ đèn sáng',
				onlineRate: 'Tỷ lệ trực tuyến',
				offlineRate: 'Tỷ lệ ngoại tuyến',
				onlineCount: 'Số lượng trực tuyến',
				offlineCount: 'Số lượng ngoại tuyến',
				leakageMonitoring: 'Phát hiện rò điện'
			}
		},
		ruleStrategy: {
			TitleH2: 'Danh sách chiến lược',
			on: 'Kích hoạt',
			off: 'Dừng',
			cancel: 'Hủy chiến lược',
			status: 'Sửa trạng thái',
			retry: 'Thử lại',
			message: 'Xem gói tin',
			name: 'Đổi tên',
		},
		alarmInfo: {
			TitleH2: {
				0: 'Tên cảnh báo',
				1: 'Mức độ cảnh báo',
				2: 'Danh sách cảnh báo',
				3: 'Phiếu công việc'
			},
			table: {
				warningName: 'Tên cảnh báo',
				warningLevel: 'Mức độ cảnh báo',
				updateTime: 'Thời gian cảnh báo',
				warningStatus: 'Trạng thái',
				option: 'Thao tác',
				error: 'Vui lòng chọn cột đèn từ thanh menu ở giữa để định vị thiết bị cảnh báo',
				error2: 'Thông tin cảnh báo bị lỗi, vui lòng liên hệ quản trị viên',
				errorDenggan: 'Cảnh báo này thuộc cột đèn, vui lòng chọn cột đèn từ thanh menu ở giữa để định vị thiết bị cảnh báo',
				errorPdg: 'Cảnh báo này thuộc tủ phân phối điện, vui lòng chọn tủ phân phối điện từ thanh menu ở giữa để định vị thiết bị cảnh báo',
				noArea: 'Thiết bị này chưa được thiết lập địa chỉ'
			},
			json: {
				shebei: 'Loại thiết bị',
				yunwei: 'Loại vận hành & bảo trì',
				nenghao: 'Loại tiêu thụ năng lượng',
				yiban: 'Cảnh báo thông thường',
				jiaoda: 'Cảnh báo mức độ vừa',
				yanzhong: 'Cảnh báo nghiêm trọng',
				normal: 'Bình thường'
			}
		},
		workOrderInfo: {
			lightOnOffTimeUndefined: 'Tạm thời không có dữ liệu',
			lightOnRate1: {
				0: 'Chưa xử lý',
				1: 'Đã xử lý'
			},
			lightOnRate2: {
				0: 'Chờ phê duyệt',
				1: 'Đang sửa chữa',
				2: 'Chờ nhận phiếu',
				3: 'Chờ kiểm tra xác nhận',
				4: 'Đã hoàn thành',
			},
			lightOnOffTime: 'Phân loại phiếu công việc',
			lightOnRate: 'Tỷ lệ xử lý phiếu công việc'
		},
		log: {
			sys: 'Nhật ký hệ thống',
			device: 'Nhật ký thiết bị'
		},
		bottom: {
			btnBox: 'Biểu đồ xu hướng năng lượng tiêu thụ',
			typeArr: {
				1: '7 ngày gần nhất',
				2: '1 tháng gần nhất',
				3: '1 năm gần nhất',
			},
			setData: {
				localEnergy: 'Năng lượng tiêu thụ hiện tại',
				sumEnergy: 'Tổng năng lượng tiêu thụ',
				weekEnergy: 'Năng lượng tiêu thụ tuần',
				monthEnergy: 'Năng lượng tiêu thụ tháng',
				yearEnergy: 'Năng lượng tiêu thụ năm',
				last7DaysEsr: 'Tỷ lệ tiết kiệm năng lượng 7 ngày qua'
			},
			echart: {
				energyChart: "Biểu đồ xu hướng năng lượng tiêu thụ",
				energy: "Năng lượng tiêu thụ",
				energySave: "Tỷ lệ tiết kiệm năng lượng",
				energyData: "Dữ liệu tiêu thụ năng lượng"
			}
		},
		baiduMap: {
			totalNumMarkerArrShowFun2: 'Quay lại chế độ xem tổng số thiết bị',
			backAreaCenterTooltip: {
				0: 'Quay về',
				1: 'Trung tâm'
			},
			viewMarkerItem: {
				0: 'Xem',
				1: 'của thiết bị'
			},
			expandMapFun: {
				0: 'Mở rộng chế độ xem',
				1: 'Khôi phục chế độ xem'
			},
			heatmapShow: {
				0: 'Hiển thị bản đồ nhiệt',
				1: 'Ẩn bản đồ nhiệt'
			},
			AlarmInfoOperationDataNull: 'Thông tin thiết bị bị lỗi, vui lòng liên hệ quản trị viên.',
			viewMarkerItemUndefined: 'Định vị thiết bị bị lỗi, vui lòng thiết lập lại trong trang quản trị.',
			noCityOrErea: 'Chưa chọn Tỉnh/Thành phố/Quận/Huyện, vui lòng chọn trước!',
			searchBox: {
				placeholder: 'Vui lòng nhập ID thiết bị'
			},
			ztList: {
				sxdy: 'Điện áp 3 pha:',
				sxdl: 'Dòng điện 3 pha:',
				sxgl: 'Công suất 3 pha:',
				sxdn: 'Điện năng 3 pha:',
				height: 'Chiều cao:',
				weight: ', Chiều rộng:',
				length: ', Chiều dài:',
				0: 'Ngoại tuyến', 
				1: 'Trực tuyến',
				2: 'Đang nâng cấp',
				3: 'Lỗi nâng cấp‌',
				wv: 'Điện áp hoạt động:',
				wvUnit: 'V, ',
				sl1: {
					zl: 'Độ sáng:',
					zs: 'Nhiệt độ màu:',
					zi: 'Dòng điện hoạt động:',
					ziUnit: 'A',
					ze: ', Năng lượng tiêu thụ:',
					zeUnit: 'KW'
				},
				sl2: {
					zl: 'Độ sáng đèn chính:',
					fl: ', Độ sáng đèn phụ:',
					zs: 'Nhiệt độ màu đèn chính:',
					fs: ', Nhiệt độ màu đèn phụ:',
					zi: 'Dòng điện hoạt động đèn chính:',
					fi: ', Dòng điện hoạt động đèn phụ:',
					ze: ', Năng lượng tiêu thụ đèn chính:',
					fe: ', Năng lượng tiêu thụ đèn phụ:'
				}
			},
			operationBox: {
				zl: 'Độ sáng chính',
				fl: 'Độ sáng phụ',
				l: 'Độ sáng',
				zs: 'Nhiệt độ màu chính',
				fs: 'Nhiệt độ màu phụ',
				s: 'Nhiệt độ màu',
				time: {
					error1: 'Vui lòng chọn thời gian cách hiện tại ít nhất 2 phút',
					error2: 'Vui lòng chọn trong vòng 45 ngày',
					error3: 'Vui lòng chọn thời gian cách hiện tại ít nhất 1 phút',
					error4: 'Vui lòng chọn thời gian sau thời điểm hiện tại',
				},
				sl2: {
					0: 'Chính',
					1: 'Phụ'
				},
				minute: 'Phút',
				offOnSwitch: {
					0: 'Tắt đèn',
					1: 'Bật đèn'
				}
			},
			contentBox: {
				denggan: 'Chi tiết cột đèn',
				Alarm: 'Chi tiết cảnh báo',
				deviceId: 'Tên thiết bị điều khiển đèn gắn trên cột',
				deviceIds: 'Chọn thiết bị điều chỉnh độ sáng'
			},
			alarmCheckbox: {
				title: 'Mức độ cảnh báo'
			},
			json: {
				markerArrInfoList: {
					installPosition: 'Vị trí lắp đặt',
					attributes: 'Thuộc tính',
					attributes2: 'Điện áp & Dòng điện',
					denggan: {
						name: 'Tên cột đèn',
						num: 'Số lượng thiết bị điều khiển gắn trên cột',
						id: 'ID cột đèn',
						time: 'Thời gian tạo'
					},
					AlarmInfo: {
						name: 'Tên thiết bị',
						id: 'ID thiết bị',
						time: 'Thời gian cảnh báo',
						state: 'Trạng thái cảnh báo',
						chaoshi: 'Cảnh báo có quá hạn không',
						type: 'Loại cảnh báo',
						email: 'Email nhận cảnh báo'
					}
				}
			}
		},
		selectProject: {
			add: 'Tạo ứng dụng',
			title: 'Chuyển đổi ứng dụng',
			Search: 'Nhập từ khóa tìm kiếm ứng dụng',
			loadEnd: 'Đã tải hết dữ liệu',
			GIS: 'Tiêu điểm GIS:',
			createTime: 'Thời gian tạo:',
			appName: 'Tên ứng dụng',
			appNameRule: 'Vui lòng nhập tên ứng dụng',
			provinceCity: 'Tiêu điểm GIS',
			provinceCityRule: 'Vui lòng chọn tiêu điểm GIS'
		}
	},
	mag: {
		router: {
			assetindex: 'Quản lý tài sản',
			assetview: 'Xem nhóm tài sản',
			deviceinfoTitle: 'Quản lý thiết bị',
			deviceinfo: 'Chi tiết TB',
			devicegroupMag: 'Quản lý nhóm',
			devicegroupMagview: 'Chi tiết quản lý nhóm',
			alarmindex: 'Phiếu cảnh báo',
			ruleStrategyindex: 'Quy tắc & Chiến lược',
			ruleStrategyInfo: 'Quản lý chiến lược',
			ruleStrategyInfoV: 'Chỉnh sửa quản lý chiến lược',
			ruleStrategyGroup: 'Nhóm TB chiến lược',
			ruleStrategyGroupV: 'Thiết lập nhóm thiết bị chiến lược',
			deviceRecord: "Bản ghi dữ liệu thiết bị",
			logindex: 'Nhật ký',
			deviceController: 'Điều khiển thiết bị',
			user: 'Quản lý người dùng',
			third: 'Tài khoản bên thứ ba',
			media: 'Thư viện phương tiện',
			deviceSearch: 'Tìm kiếm thiết bị',
			deviceTotal: 'Thống kê thiết bị',
			communication: 'Quản lý truyền thông',
			Setting: 'Cấu hình',
			energy: 'Thống kê năng lượng',
			activity: 'Báo cáo hoạt động',
			workinfoTitle: 'Quản lý phiếu công việc',
			worktransfer: 'Cảnh báo chuyển thành phiếu công việc',
			workinfo: 'Tôi đã tạo',
			workHandle: 'Tôi xử lý',
			workHistory: 'Lịch sử xử lý',
			sim: 'Thông tin thẻ SIM',
			scene: 'Kịch bản chiếu sáng',
			configuration: 'Cấu hình mẫu kịch bản sản phẩm',
			mode: 'Chế độ kịch bản',
			deviceinfoS: 'Thiết bị',
			devicegroupMagS: 'Nhóm',
			SettingS: 'Cấu hình',
			energyS: 'Năng lượng',
			activityS: 'Hoạt động',
			simS: 'Thẻ SIM',
			sceneS: 'Kịch bản',
			worktransferS: 'Chuyển phiếu',
			workinfoS: 'Tạo',
			workHandleS: 'Xử lý',
			workHistoryS: 'Lịch sử',
			logindexS: 'Nhật ký',
			userS: 'Quản lý',
			thirdS: 'Bên thứ ba',
			ruleStrategyInfoS: 'Chiến lược',
			ruleStrategyGroupS: 'Nhóm',
			task: "Nhiệm vụ tuần tra",
			taskRecord: "Nhật ký tuần tra",
			taskS: "Tuần tra",
			taskRecordS: "Nhật ký",
			lightRate:'Tỷ lệ chiếu sáng',
			lightRateS:'Đèn sáng',
		},
		components: {
			tableBox: {
				description: 'Đang tải...',
				option: 'Thao tác',
				edit: 'Chỉnh sửa',
				del: 'Xóa',
				handle: 'Xử lý',
				view: 'Chi tiết',
				delSuccess: 'Xóa thành công!',
				delError: 'Xóa thất bại, vui lòng liên hệ quản trị viên',
				pagination: {
					pagesize: "mục/trang",
					total: "Tổng cộng:",
					pageClassifier: "Chuyển đến",
				}
			},
			addEditDrawer: {
				edit: 'Chỉnh sửa',
				addSuccess: 'Thêm',
				success: 'Thành công!',
				clone: 'Sao chép',
				error: 'Thêm thất bại, vui lòng liên hệ quản trị viên',
				authority: 'Vui lòng chọn quyền ứng dụng!'
			},
			searchBox: {
				add: 'Thêm mới'
			},
			searchDiv: {
				searchPlaceholder: 'Tìm kiếm',
				PopoverBox: {
					title: 'Tìm kiếm nâng cao'
				}
			},
			leftTree: {
				title: 'Sơ đồ cây thiết bị',
				placeholder: 'Vui lòng nhập từ khóa tìm kiếm'
			}
		},
		tabsList: {
			Light: 'Điều khiển đèn',
			Pole: 'Cột đèn',
			Ggd: 'Tủ phân phối điện',
			jcqnb: 'Cấu hình lịch biểu contactor',
			tgnb: 'Cấu hình lịch biểu điều chỉnh độ sáng',
			lightTypeMag: 'Loại chiếu sáng'
		},
		alarm: {
			tabsList: {
				warning: 'Cảnh báo',
				workOrder: 'Phiếu công việc'
			},
			btnList: {
				add: 'Tạo phiếu công việc',
			},
			tableColumn: {
				id: 'ID cảnh báo',
				warningName: 'Tên cảnh báo',
				devicesId: 'Mã thiết bị',
				warningType: 'Loại cảnh báo',
				warningLevel: 'Mức độ cảnh báo',
				warningStatus: 'Trạng thái cảnh báo',
				warningDeal: 'Xử lý cảnh báo',
				updateTime: 'Thời gian cập nhật lần cuối'
			},
			tableColumn2: {
				warningIds: 'ID cảnh báo liên kết',
				name: 'Tên phiếu công việc',
				warningNames: 'Tên cảnh báo liên kết',
				responsiblePerson: 'Danh sách phân công phiếu',
				responsibleEmail: 'Email phân công phiếu',
				workStatus: 'Trạng thái xử lý phiếu',
				updateTime: 'Thời gian cập nhật lần cuối'
			},
			addEditDrawer: {
				warningDealId: 'Xử lý cảnh báo:',
				rules: {
					warningDealId: 'Vui lòng chọn cách xử lý cảnh báo'
				}
			},
			addEditDrawer2: {
				warningIds: 'Tên cảnh báo:',
				name: 'Tên phiếu công việc:',
				category: 'Phân loại phiếu:',
				responsiblePerson: 'Danh sách phân công phiếu:',
				responsibleEmail: 'Email phân công phiếu:',
				workStatus: 'Trạng thái xử lý phiếu:',
				rules: {
					workStatus: 'Vui lòng chọn trạng thái xử lý phiếu',
					warningIds: 'Vui lòng chọn tên cảnh báo',
					category: 'Vui lòng chọn phân loại phiếu',
					name: 'Vui lòng nhập tên phiếu công việc',
					responsiblePerson: 'Vui lòng nhập danh sách phân công',
					responsibleEmail: 'Vui lòng nhập email phân công'
				}
			}
		},
		asset: {
			tableColumn: {
				name: 'Tên nhóm tài sản',
				companyName: 'Đơn vị trực thuộc',
				assetLightPoleCount: 'Số lượng cột đèn',
				assetLightCount: 'Số lượng bộ điều khiển đèn',
				assetGgdCount: 'Số lượng tủ điện',
				updateTime: 'Thời gian cập nhật lần cuối'
			},
			addEditDrawer: {
				name: 'Tên nhóm tài sản:',
				companyName: 'Đơn vị trực thuộc:',
				groupIds: 'Chọn nhóm:',
				rules: {
					name: 'Vui lòng nhập tên nhóm tài sản',
					companyName: 'Vui lòng nhập đơn vị trực thuộc',
				},
			},
			view: {
				tableColumn: {
					name: {
						Ggd: 'Tên tủ điện tài sản',
						Pole: 'Tên cột đèn tài sản',
						Light: 'Tên bộ điều khiển đèn'
					},
					deviceId: 'Mã thiết bị',
					installPosition: 'Vị trí lắp đặt',
					installTime: 'Thời gian lắp đặt',
					height: 'Chiều cao',
					weight: 'Chiều rộng',
					longitude: 'Kinh độ',
					latitude: 'Vĩ độ',
					updateTime: 'Thời gian cập nhật mới nhất',
					material: 'Chất liệu',
					poleType: 'Loại cột đèn',
					armType: 'Loại cần đèn',
					lightPoleName: 'Tên cột đèn',
					lampCapType: 'Loại nguồn sáng',
					lampCapCount: 'Số lượng nguồn sáng',
					assetGgdName: 'Tủ điện trực thuộc'
				},
				addEditDrawer: {
					deviceId: 'Thiết bị:',
					hlbh: 'Mã mạch điện',
					hlkg: 'Công tắc mạch điện',
					name: {
						Ggd: 'Tên tủ điện tài sản:',
						Pole: 'Tên cột đèn tài sản:',
						Light: 'Tên bộ điều khiển đèn:'
					},
					assetGgdId: 'Tủ điện:',
					provinceCityArea: 'Tỉnh/Thành phố:',
					installPosition: 'Vị trí lắp đặt:',
					installTime: 'Thời gian lắp đặt:',
					height: 'Chiều cao:',
					weight: 'Chiều rộng:',
					longitude: 'Kinh độ:',
					latitude: 'Vĩ độ:',
					material: 'Chất liệu:',
					poleType: 'Loại cột đèn:',
					armType: 'Loại cần đèn:',
					lightPoleId: 'Cột đèn:',
					lampCapType: 'Loại nguồn sáng:',
					lampCapCount: 'Số lượng nguồn sáng:',
					rules: {
						deviceId: 'Vui lòng chọn thiết bị',
						name: {
							Ggd: 'Vui lòng nhập tên tủ điện tài sản',
							Pole: 'Vui lòng nhập tên cột đèn',
							Light: 'Vui lòng nhập tên bộ điều khiển đèn'
						},
					}
				}
			}
		},
		device: {
			LOnline:'Đèn trực tuyến',
			LOffline:'Đèn ngoại tuyến',
			COnline:'Số lượng bộ tập trung trực tuyến',
			COffline:'Số lượng bộ tập trung ngoại tuyến',
			tai:'Cái',
			info: {
				searchPlaceholder: 'Vui lòng nhập ID thiết bị',
				btnList: {
					energyReplace: 'Kế thừa điện năng',
					add: 'Đăng ký thiết bị đơn lẻ',
					addMore: 'Đăng ký hàng loạt',
					addMore1: 'Đăng ký thiết bị Hikvision',
					addLnglatMore: 'Nhập kinh vĩ độ hàng loạt',
					update: 'Nâng cấp thiết bị',
					export: 'Xuất dữ liệu',
					exportExcel: 'Xuất file Excel',
					exportWord: 'Xuất file Word',
				},
				tableColumn: {
					devicesId: 'Mã thiết bị',
					devicesName: 'Tên thiết bị',
					regTime: 'Thời gian đăng ký',
					hardWare: 'Phiên bản firmware',
					groupName: 'Tên nhóm',
					productName: 'Tên sản phẩm',
					categoryName: 'Tên phân loại thiết bị',
					onlineStatus: 'Trạng thái',
					updateTime: 'Thời gian cập nhật mới nhất',
					timeZone: 'Múi giờ',
				},
				addEditDrawer: {
					devicesId: 'Mã thiết bị:',
					devicesName: 'Tên thiết bị:',
					productId: 'Sản phẩm:',
					groupId: 'Nhóm thiết bị:',
					groupIdaddOption: {
						0: 'Chưa phân nhóm'
					},
					categoryId: 'Phân loại:',
					mountDevicesId: 'Bộ tập trung gắn kèm:',
					mountDevicesId1: 'NVR gắn kèm:',
					mountChannel: 'Kênh',
					onlineStatus: 'Trạng thái trực tuyến:',
					devicesRegisterTime: 'Thời gian đăng ký thiết bị:',
					timeZone: 'Múi giờ:',
					softWare: 'Phiên bản phần mềm:',
					hardWare: 'Phiên bản phần cứng:',
					cid: 'Số thẻ liên lạc:',
					imei: 'IMEI thiết bị:',
					rules: {
						devicesId: 'Vui lòng nhập mã thiết bị',
						devicesName: 'Vui lòng nhập tên thiết bị',
						productId: 'Vui lòng chọn sản phẩm',
						categoryId: 'Vui lòng chọn phân loại'
					}
				},
				editBoxData: {
					sourceDeviceId: 'ID thiết bị nguồn',
					targetDeviceId: 'ID thiết bị đích',
					rules: {
						deviceRegular: 'Định dạng mã thiết bị không chính xác',
					}
				},
				upDate: {
					upload__text: {
						0: 'Kéo tệp vào đây hoặc',
						1: 'nhấp để tải lên'
					},
					uploading: 'Đang tải lên',
					uploadSuccessList: {
						firmwareName: 'Tên firmware:'
					},
					confirm: 'Nâng cấp',
					success: 'Thao tác thành công, đang tiến hành nâng cấp.',
					uploadSuccessList0: 'Vui lòng tải lên tệp firmware',
					uploadSuccessList1: 'Đang tải lên tệp firmware',
					formItem: {
						productId: 'Sản phẩm:',
						groupId: 'Nhóm thiết bị:',
						retryNum: "Số lần thử lại",
						delayLevel: "Thời gian chờ",
						subSize: "Kích thước gói phân đoạn",
						retryNumTip: "Số lần từ 0-5",
						retryNumRule: "Số lần thử lại từ 0-5"
					},
					tableColumn: {
						devicesId: 'Mã thiết bị',
						devicesName: 'Tên thiết bị',
						hardWare: 'Phiên bản firmware',
						groupName: 'Tên nhóm'
					}
				},
				addMore: {
					modelDown: 'Tải về mẫu',
					loadFile: 'Tải tệp',
					register: 'Nhấn để đăng ký',
					success: 'Đăng ký thành công:',
					error: 'Khác:',
					batchRegErr: 'Mã đăng ký thất bại:',
					deviceErrTip: ' định dạng ID thiết bị không hợp lệ, vui lòng kiểm tra lại trước khi tải lên!',
					emptyLine: ' ID thiết bị ở dòng này không tồn tại',
					uploadSuccessBox: {
						uploadSuccessList: {
							title: 'Đăng ký thành công:',
							title2: 'Nhập kinh vĩ độ thành công:',
							num: 'Mã thiết bị:'
						},
						uploadErrorList: {
							title: 'Đăng ký thất bại:',
							title2: 'Nhập kinh vĩ độ thất bại:',
						}
					}
				}
			},
			groupMag: {
				tableColumn: {
					groupName: 'Tên nhóm',
					productName: 'Tên sản phẩm',
					status: 'Trạng thái',
					updateTime: 'Thời gian cập nhật',
					assetSumName: 'Nhóm tài sản trực thuộc'
				},
				btnList: {
					add: 'Thêm nhóm mới'
				},
				addEditDrawer: {
					groupName: 'Tên nhóm:',
					productId: 'Sản phẩm:',
					status: 'Trạng thái:',
					assetSumId: 'Nhóm tài sản',
					rules: {
						groupName: 'Vui lòng nhập tên nhóm',
						assetSumId: 'Vui lòng chọn nhóm tài sản',
						productId: 'Vui lòng chọn sản phẩm',
					}
				},
				view: {
					selection0: 'Vui lòng chọn thiết bị để thao tác',
					TableBox: {
						add: 'Thêm cấu hình nhóm',
						del: 'Hủy cấu hình nhóm'
					},
					btnList: {
						editDevicesGroup: 'Phân nhóm thiết bị hàng loạt',
						editDevicesGroupOut: 'Xóa khỏi nhóm thiết bị hàng loạt'
					},
					PopoverformItem: {
						productId: 'Sản phẩm:',
						productIdaddOption: {
							0: 'Tất cả'
						},
						categoryId: 'Phân loại:',
						assetSumId: 'Nhóm tài sản:'
					},
					tableColumn: {
						devicesId: 'Mã thiết bị',
						devicesName: 'Tên thiết bị',
						productName: 'Tên sản phẩm',
						categoryName: 'Tên loại thiết bị',
						updateTime: 'Thời gian nhập kho thiết bị'
					}
				}
			},
			setting: {
				last: "Tháng trước",
				todey: "Hôm nay",
				next: 'Tháng sau',
				batch: 'Sửa đổi lịch trình hàng loạt',
				enSet: 'Cấu hình tiết kiệm năng lượng',
				basePower: 'Điện năng chuẩn chung',
				totalPower: 'Tổng công suất thiết bị (kW)',
				ennualEnergy: 'Điện năng chuẩn 1 năm',
				usageHours: 'Thời gian sử dụng (giờ)',
				dailyEnergy: 'Điện năng chuẩn hàng ngày',
				deviceSumKWh: "Điện năng chuẩn (kWh)",
				deviceKWh: "Điện năng chuẩn"
			}
		},
		scene: {
			configuration: {
				disable: 'Vô hiệu hóa',
				enable: 'Kích hoạt',
				name: "Tên cấu hình",
				type: "Loại sản phẩm",
				instruct: "Lệnh điều khiển",
				parameter: "Tham số động",
				creator: "Người tạo",
				upDataTime: "Thời gian cập nhật gần nhất",
				status: "Trạng thái",
				addTitle: 'Thêm cấu hình mới',
			},
			mode: {
				scene: "Thực thi kịch bản",
				name: "Tên kịch bản",
				type: "Loại chế độ",
				deviceType: 'Loại thiết bị',
				config: "Cấu hình mẫu sản phẩm",
				creator: "Người tạo",
				upDataTime: "Thời gian cập nhật gần nhất",
				addTitle: 'Thêm kịch bản mới'
			}
		},
		activity: {
			btnList: {
				exportExcel: 'Xuất file Excel',
				exportWord: 'Xuất file Word'
			},
			exportWord: {
				timeConfig: 'Cấu hình thời gian:',
				deviceId: 'Mã thiết bị:',
				deviceGroupId: 'Nhóm thiết bị:',
			},
			exportExcel: {
				wvMin: 'Điện áp hoạt động tối thiểu',
				wvMax: 'Điện áp hoạt động tối đa',
				ziMax: 'Dòng điện hoạt động đèn chính tối đa',
				ziMin: 'Dòng điện hoạt động đèn chính tối thiểu',
				fiMax: 'Dòng điện hoạt động đèn phụ tối đa',
				fiMin: 'Dòng điện hoạt động đèn phụ tối thiểu',
				zpMax: 'Công suất hữu công đèn chính tối đa',
				zpMin: 'Công suất hữu công đèn chính tối thiểu',
				fpMax: 'Công suất hữu công đèn phụ tối đa',
				fpMin: 'Công suất hữu công đèn phụ tối thiểu',
				wv: 'Điện áp hoạt động tối đa và tối thiểu:',
				zi: 'Dòng điện hoạt động đèn chính tối đa và tối thiểu:',
				fi: 'Dòng điện hoạt động đèn phụ tối đa và tối thiểu:',
				zp: 'Công suất hữu công đèn chính tối đa và tối thiểu:',
				fp: 'Công suất hữu công đèn phụ tối đa và tối thiểu:',
				tg: 'Điều chỉnh độ sáng',
				maxMin: 'Giá trị tối đa và tối thiểu',
				max: 'Giá trị tối đa',
				min: 'Giá trị tối thiểu',
				hl: 'Mạch điện',
				minDim1: "Độ sáng 1 tối thiểu",
				minDim2: "Độ sáng 2 tối thiểu",
				minDim3: "Độ sáng 3 tối thiểu",
				minDim4: "Độ sáng 4 tối thiểu",
				minDim5: "Độ sáng 5 tối thiểu",
				minDim6: "Độ sáng 6 tối thiểu",
				minDim7: "Độ sáng 7 tối thiểu",
				minDim8: "Độ sáng 8 tối thiểu",
				maxDim1: 'Độ sáng 1 tối đa',
				maxDim2: 'Độ sáng 2 tối đa',
				maxDim3: 'Độ sáng 3 tối đa',
				maxDim4: 'Độ sáng 4 tối đa',
				maxDim5: 'Độ sáng 5 tối đa',
				maxDim6: 'Độ sáng 6 tối đa',
				maxDim7: 'Độ sáng 7 tối đa',
				maxDim8: 'Độ sáng 8 tối đa',
			}
		},
		task: {
			task: {
				tableColumn: {
					taskName: "Tên nhiệm vụ",
					taskType: "Loại nhiệm vụ",
					cronExpr: "Biểu thức Cron",
					targetType: "Loại mục tiêu tuần tra",
					status: "Trạng thái nhiệm vụ",
					remark: 'Ghi chú',
					updateByName: "Biệt danh người cập nhật",
					updateTime: "Thời gian cập nhật",
				},
				taskName: 'Tên nhiệm vụ:',
				taskType: 'Loại nhiệm vụ:',
				cronExpr: 'Biểu thức Cron:',
				targetType: 'Loại mục tiêu tuần tra:',
				targetContent: 'Nội dung mục tiêu tuần tra:',
				remark: 'Ghi chú:'
			},
			record: {
				tableColumn: {
					taskName: "Tên nhiệm vụ",
					execTime: "Thời gian thực hiện",
					execStatus: "Trạng thái thực hiện",
					totalItem: "Tổng số hạng mục tuần tra",
					successItem: "Số hạng mục bình thường",
					failItem: "Số hạng mục bất thường",
					execCost: "Thời gian thực thi (ms)",
					execWay: "Phương thức thực thi",
					operator: "Biệt danh người thao tác",
					createTime: "Thời gian tạo",
				},
			},
			fiveRun: "Thời gian chạy 5 lần gần nhất:",
			inspection: "Kết quả tuần tra gần nhất:",
			targetId: 'Mục tiêu tuần tra',
			targetName: 'Tên mục tiêu tuần tra',
			isNormal: 'Có bình thường không',
			errorMsg: 'Thông tin bất thường',
			execCost: 'Thời gian thực thi mục này (ms)',
			total: 'Tổng số lượng',
			success: 'Số lượng thành công',
			completedCount: 'Số lượng hoàn thành kiểm tra',
		},
		work: {
			rules: {
				name: "Vui lòng nhập tên phiếu công việc",
				alarm: "Vui lòng chọn cảnh báo liên kết",
				priority: "Vui lòng chọn mức độ ưu tiên",
				responsiblePerson: 'Vui lòng nhập danh sách phân công',
				workStatus: 'Vui lòng chọn',
				warningIds: 'Cảnh báo liên kết'
			},
			detail: {
				workMsg: 'Thông tin phiếu công việc',
				responsiblePerson: 'Người được phân công',
				workWarning: "Cảnh báo của phiếu",
				phone: 'Số điện thoại',
				smsStatus: 'Trạng thái gửi tin nhắn SMS',
				confirmStatus: 'Trạng thái xác nhận',
				nickname: 'Biệt danh người được phân công',
				confirmTime: 'Thời gian xác nhận',
				warnId: 'ID cảnh báo',
				warningName: 'Tên cảnh báo',
				devicesId: 'Mã thiết bị',
				warningType: 'Loại cảnh báo',
				warningLevel: 'Mức độ cảnh báo',
				initWorkOrder: "Khởi tạo phiếu công việc",
				processWorkOrder: "Nhân viên sửa chữa nhận phiếu",
				examineWorkOrder: "Phê duyệt thời gian sửa chữa",
				repairSuccess: "Phê duyệt hoàn thành sửa chữa",
				verifyResult: "Phê duyệt kiểm tra kết quả",
				process: 'Thông tin xét duyệt quy trình hiện tại',
				user: 'Người dùng',
				opinion: 'Ý kiến phê duyệt',
				estimatedFinshTime: 'Thời gian sửa chữa dự kiến',
				damageReason: 'Nguyên nhân hư hỏng',
				repairTimeStatus: "Phê duyệt thời gian sửa chữa",
				finishStatus: 'Kết quả xét duyệt',
				comment: 'Ý kiến xét duyệt',
				describe: "Mô tả",
				location: 'Xem vị trí',
				initiated: 'Đã khởi tạo',
			},
			info: {
				btnList: {
					add: 'Tạo phiếu công việc',
					ignore: 'Bỏ qua cảnh báo'
				},
				tableColumn: {
					name: 'Tên phiếu công việc',
					num: 'Mã số',
					alertName: 'Tên cảnh báo liên kết',
					alertID: 'ID cảnh báo liên kết',
					status: 'Trạng thái phiếu',
					creator: 'Người tạo',
					assignee: 'Người xử lý',
					createTime: 'Thời gian tạo',
					priority: 'Mức độ ưu tiên',
				},
				workID: "Mã phiếu công việc:",
				workName: "Tên phiếu công việc:",
				alarm: "Cảnh báo liên kết:",
				priority: "Mức độ ưu tiên:",
				responsiblePerson: 'Danh sách phân công phiếu:',
				workStatus: 'Đã khởi tạo chưa:',
				comment: 'Ý kiến xét duyệt:',
				search: ' Nhập tên phiếu công việc'
			},
			handle: {
				tableColumn: {
					num: 'Mã số',
					name: 'Tên phiếu công việc',
					status: 'Trạng thái',
					type: 'Loại',
					priority: 'Mức độ ưu tiên',
					creator: 'Người tạo',
					assignee: 'Người xử lý',
					createTime: 'Thời gian tạo',
					updateTime: 'Thời gian cập nhật',
				},
			},
			history: {
				tableColumn: {
					num: 'Mã số',
					name: 'Tên phiếu công việc',
					type: 'Loại',
					reason: 'Nguyên nhân',
					priority: 'Mức độ ưu tiên',
					creator: 'Người tạo',
					assignee: 'Người xử lý',
					createTime: 'Thời gian tạo',
					endTime: 'Thời gian kết thúc',
				},
			}
		},
		log: {
			tabsList: {
				device: 'Nhật ký thiết bị',
				sys: 'Nhật ký hệ thống'
			},
			tableColumn: {
				devicesId: 'Mã thiết bị',
				consumer: 'Đối tượng được thao tác',
				createTime: 'Thời gian tạo',
				content: 'Nội dung nhật ký',
				createNickname: 'Biệt danh người tạo',
				deviceGroupName: 'Tên nhóm thiết bị',
				deviceProductName: 'Tên sản phẩm thiết bị',
				appName: 'Tên ứng dụng',
				producerName: 'Tên thiết bị',
				consumerJson: 'Gói tin thiết bị',
				producerJson: 'Gói tin hệ thống',
				status: 'Trạng thái'
			},
			btnList: {
				export: 'Xuất dữ liệu',
				clear: 'Xóa toàn bộ nhật ký',
				del: 'Xóa',
				delError: 'Vui lòng chọn thời gian trước'
			},
			formItem: {
				time: 'Khoảng thời gian:',
				type: 'Loại tham số:',
				hlTime: 'Thời gian duy trì',
			}
		},
		ruleStrategy: {
			tabsList: {
				info: 'Thông tin chiến lược',
				record: 'Nhật ký điều khiển thiết bị'
			},
			tableColumn: {
				name: 'Tên chiến lược',
				type: 'Loại chiến lược',
				runUnit: 'Đơn vị thực thi',
				effectTime: 'Thời gian hiệu lực',
				invalidTime: 'Thời gian hết hiệu lực',
				runTime: 'Thời gian thực thi',
				targetIdList: 'Mã thiết bị',
				status: 'Trạng thái'
			},
			addEditDrawer: {
				name: 'Tên chiến lược:',
				status: 'Trạng thái:',
				type: 'Loại:',
				productId: 'Sản phẩm:',
				triggerId: 'Bộ kích hoạt:',
				judgmentId: 'Quy tắc tính toán:',
				disposerId: 'Bộ xử lý:',
				time: 'Thời gian hiệu lực - Hết hiệu lực:',
				runTime: 'Thời gian thực thi:',
				runUnit: 'Đơn vị thực thi:',
				targetType: 'Loại mục tiêu liên kết:',
				targetIdList: 'Mục tiêu liên kết:',
				effectEverydayTime: 'Khung giờ hiệu lực hàng ngày:',
				effectEverydayTime1: 'Nhóm 1:',
				effectEverydayTime2: 'Nhóm 2:',
				rules: {
					name: 'Vui lòng nhập tên chiến lược',
					status: 'Vui lòng chọn trạng thái',
					type: 'Vui lòng chọn loại',
					productId: 'Vui lòng chọn sản phẩm',
					triggerId: 'Vui lòng chọn bộ kích hoạt',
					judgmentId: 'Vui lòng chọn quy tắc tính toán',
					disposerId: 'Vui lòng chọn bộ xử lý',
					runUnit: 'Vui lòng chọn đơn vị thực thi',
					targetType: 'Vui lòng chọn loại mục tiêu liên kết',
					targetIdList: 'Vui lòng chọn mục tiêu liên kết',
				}
			},
			btnList: {
				add: 'Thêm chiến lược mới',
				add1: 'Thêm chiến lược sự kiện mới',
				add2: 'Thêm chiến lược hẹn giờ mới'
			},
			recordTableColumn: {
				deviceId: 'Mã thiết bị',
				name: 'Tên thiết bị',
				status: 'Trạng thái',
				type: 'Loại',
				lastSendTime: 'Thời gian gửi lệnh gần nhất',
			},
			messageTableColumn: {
				devicesId: 'ID thiết bị',
				sendBody: 'Nội dung gói tin gửi đi',
				responseBody: 'Nội dung gói tin phản hồi',
				status: 'Trạng thái',
				type: 'Loại',
			},
			recordBtnList: {
				refresh: 'Làm mới'
			},
		},
		ruleStrategyGroup: {
			tableColumn: {
				groupName: 'Tên nhóm',
				name: 'Tên sản phẩm',
				updateTime: 'Thời gian cập nhật',
			},
			formItem: {
				groupName: 'Tên nhóm:',
				product: 'Sản phẩm:',
				select: 'Chọn thiết bị:',
				group: 'Nhóm thiết bị:',
				groupSelect: 'Vui lòng chọn nhóm',
			},
		},
		deviceController: {
			camera: {
				actual: 'Phát trực tiếp',
				replay: 'Phát lại giám sát',
				screenshot: 'Chụp ảnh màn hình',
				PreviewAll: 'Bắt đầu xem trước tất cả',
				stop: 'Dừng',
				play: 'Phát',
				allPlay: "Phát tất cả",
				treamType: 'Loại luồng phát',
				mainStream: 'Luồng chính',
				subStream: 'Luồng phụ',
				stopAll: 'Dừng tất cả',
				screenSplit: 'Chia khung hình',
				fullScreen: 'Toàn màn hình',
				page: 'Khung hình',
				channel: 'Kênh',
				channelTip: "Thiết bị này chưa thiết lập kênh, vui lòng thiết lập kênh trước!",
				configTip: 'Thiết bị này chưa thiết lập cấu hình, vui lòng thiết lập cấu hình trước!',
				PTZControlTip: 'Thiết bị này không hỗ trợ điều khiển xoay PTZ!',
				loginError: 'Đăng nhập thất bại!'
			},
			mf: {
				vjl: 'Hệ số đo điện áp',
				zijl: 'Hệ số đo dòng điện đèn chính',
				fijl: 'Hệ số đo dòng điện đèn phụ',
				zpjl: 'Hệ số đo công suất đèn chính',
				fpjl: 'Hệ số đo công suất đèn phụ',
			},
			ggdViewBox: {
				getDDQKGGTG: 'Xem cảm biến ánh sáng nhóm đèn đơn',
				getDDZR: 'Xem lịch ngày đúng giờ nhóm đèn đơn',
				getSxjlxs: 'Xem hệ số đo',
				HLZR: 'Xem lịch ngày đúng giờ mạch điện',
				getDDJR: 'Xem lịch ngày tính giờ nhóm đèn đơn',
				baseInfo: 'Thông tin cơ bản',
				getTgzr: 'Xem lịch ngày đúng giờ điều sáng',
				getTgnb: 'Xem lịch năm điều sáng',
				getTgggVO: 'Xem cài đặt cảm biến ánh sáng',
				getHlfdtg: 'Xem phân đoạn điều sáng cảm biến quang',
				getWarnsafe: 'Bảo vệ cảnh báo mưa tuyết',
				hideinfoBox: {
					0: 'Hiển thị thêm',
					1: 'Ẩn'
				},
				minute: 'Phút',
				getHlNb: 'Xem lịch năm mạch điện',
				JcqStatusListDataTitle: 'Trạng thái mạch điện',
				RealTimeData: 'Dữ liệu thời gian thực',
				AlarmWidth: 'Ngưỡng cảnh báo',
				flowSensorVO: 'Danh sách cảm biến lưu lượng xe',
				illuminantSensorVO: 'Danh sách cảm biến độ rọi ánh sáng',
				wloggingSensorVO: 'Danh sách cảm biến ngập nước',
				rainsnowSensorVO: 'Danh sách cảm biến mưa tuyết',
				poweroffProtectionVO: 'Danh sách thiết bị bảo vệ mất điện',
				ddldggldList: 'Thiết lập chế độ liên kết Radar - Quang cảm',
				deviceID: 'Mã thiết bị',
				deviceName: 'Tên thiết bị',
				trafficFlow: 'Lưu lượng xe',
				illumination: 'Độ rọi ánh sáng',
				water: 'Ngập nước',
				offline: 'Có mất điện không',
				yx: 'Trạng thái mưa tuyết',
				RTC: 'Phát hiện mục tiêu Radar',
				433: 'Mô-đun truyền thông 433',
				infoLabelList: {
					4: {
						id: 'ID thiết bị',
						devicesName: 'Tên thiết bị',
						onlineStatus: 'Trạng thái trực tuyến',
						sxdn: 'Điện năng 3 pha',
						sbxh: 'Kiểu máy thiết bị (Model)',
						productName: 'Tên sản phẩm',
						mzxh: 'Kiểu mô-đun (Module Model)',
						rtcsj: 'Thời gian thiết bị',
						yxsj: 'Thời gian hoạt động',
						jwd: 'Kinh vĩ độ',
						jwdLng: 'Kinh độ',
						jwdLat: 'Vĩ độ',
						hgqzsb: 'Tỷ số vòng biến dòng (CT)',
						jzqczkg: 'Công tắc thao tác bộ tập trung',
						tgbc: 'Bù sáng tự thích ứng',
						jwsj: 'Giờ địa phương theo kinh vĩ độ',
						jwpyz: 'Độ lệch thời gian địa phương theo kinh vĩ độ',
						jwpyzT: 'Thời gian lệch địa phương theo kinh vĩ độ',
						jwpyzLabel: {
							0: 'Bình minh',
							1: 'Hoàng hôn'
						},
						jcqrbms: 'Chế độ mạch điện',
						jcqrbmssortableArrUnit: 'Lộ',
						tgrbms: 'Chế độ lịch ngày',
						ntgv: 'Điện áp thời gian thực',
						tglj: 'Logic điều chỉnh độ sáng',
						sxdy: 'Điện áp 3 pha',
						sxdl: 'Dòng điện 3 pha',
						sxgl: 'Công suất điện 3 pha',
						sxdlAll: 'Tổng dòng điện 3 pha',
						sxdnAll: 'Tổng điện năng 3 pha',
						sxglAll: 'Tổng công suất 3 pha',
						wdgjyz: 'Ngưỡng cảnh báo nhiệt độ thiết bị',
						temp: 'Nhiệt độ thiết bị',
						sxdlgjyz: 'Ngưỡng cảnh báo dòng điện 3 pha',
						sxdlgjyzAmin: 'Pha A min',
						sxdlgjyzAmax: 'Pha A max',
						sxdlgjyzBmin: 'Pha B min',
						sxdlgjyzBmax: 'Pha B max',
						sxdlgjyzCmin: 'Pha C min',
						sxdlgjyzCmax: 'Pha C max',
						sxdygjyz: 'Ngưỡng cảnh báo điện áp 3 pha',
						sxgjsn: 'Kích hoạt cảnh báo',
						sxgjsnA: 'Kích hoạt cảnh báo pha A',
						sxgjsnB: 'Kích hoạt cảnh báo pha B',
						sxgjsnC: 'Kích hoạt cảnh báo pha C',
						sxgjsnsortableArr: {
							0: 'Kích hoạt cảnh báo điện áp',
							1: 'Kích hoạt cảnh báo dòng điện',
							2: 'Kích hoạt cảnh báo nhiệt độ'
						},
						hardWare: 'Phiên bản phần cứng',
						softWare: 'Phiên bản phần mềm',
						hlggsz: 'Thông số quang cảm mạch điện',
						hlggszArr: {
							0: 'Độ sáng',
							1: 'Độ trễ'
						},
						lxkg: 'Công tắc thăm dò (Polling)',
						lxzq: 'Chu kỳ thăm dò',
						sbsjzq: 'Chu kỳ heartbeat',
						gjzq: 'Chu kỳ cảnh báo',
						ddqkrbms: 'Chế độ lịch ngày nhóm đèn đơn',
						temp: 'Nhiệt độ thiết bị',
						wlid: 'ID mạng',
						kglsc: '3 ngõ ra tín hiệu số',
						kglsr: '3 ngõ vào tín hiệu số',
						ntgz: 'Giá trị điều sáng',
						dlbh: 'Công tắc bảo vệ ngắn mạch dây điều chỉnh độ sáng',
						tgdls: 'Tình trạng ngắn mạch',
						tgmrv: 'Điện áp mặc định khi khởi động'
					}
				}
			},
			searchPlaceholder: 'Vui lòng nhập mã thiết bị để tìm kiếm',
			tabsList: {
				Light: "MQTT",
				sys: 'TCP'
			},
			setHlgg: {
				ld: 'Độ sáng',
				hc: 'Độ trễ'
			},
			setDdldggld: {
				ldldkg: 'Công tắc liên kết Radar',
				ldcfldsj: 'Thời gian sáng đèn kích hoạt bởi Radar (giây)',
				ggldkg: 'Công tắc liên kết quang cảm',
				mrld: 'Độ sáng mặc định',
				mrsw: 'Nhiệt độ màu mặc định',
				ldMinld: 'Độ sáng liên kết tối thiểu',
				ldMaxld: 'Độ sáng liên kết tối đa',
			},
			dimTg: {
				tgNums: 'Mã điều chỉnh độ sáng',
				tgPercent: 'Giá trị điều chỉnh độ sáng',
				yf: 'Tháng'
			},
			setJwdpyz: {
				rcpyz: 'Độ lệch bình minh (giây)',
				rlpyz: 'Độ lệch hoàng hôn (giây)',
				rcld: 'Độ sáng bình minh',
				rlld: 'Độ sáng hoàng hôn'
			},
			setGJZQ: {
				gjzq: 'Chu kỳ cảnh báo (phút)'
			},
			setHgqzsb: {
				hgqzsb: 'Tỷ số vòng biến dòng (CT)'
			},
			setSbsjzq: {
				sbsjzq: 'Chu kỳ heartbeat (giây)'
			},
			setLdcs: {
				ldsn: 'Kích hoạt liên kết',
				ldys: 'Thời gian trễ liên kết (giây)',
				ldcs: 'Thời gian quá hạn liên kết (giây)'
			},
			setJzqczkg: {
				jzqczkg: 'Công tắc thao tác bộ tập trung'
			},
			setKglsc: {
				kglsc1: 'Lộ 1',
				kglsc2: 'Lộ 2',
				kglsc3: 'Lộ 3'
			},
			syncHlNb: {
				jcqNum: 'Mã mạch điện',
				jcqyf: 'Tháng'
			},
			setHlNb: {
				jcqnbId: 'Lịch năm',
				jcqnbNum: 'Mã mạch điện'
			},
			setHlRm: {
				jcqkg1: 'Lộ 1',
				jcqkg2: 'Lộ 2',
				jcqkg3: 'Lộ 3',
				jcqkg4: 'Lộ 4',
				jcqkg5: 'Lộ 5',
				jcqkg6: 'Lộ 6',
				jcqkg7: 'Lộ 7',
				jcqkg8: 'Lộ 8'
			},
			setHLZR: {
				todaySeconds: 'Thời gian',
				time: 'Thời gian (phút)',
				keepTime: 'Thời gian (phút)',
				group: {
					0: 'Thứ',
					1: 'Nhóm',
					2: 'Lộ'
				},
				zl: 'Độ sáng chính',
				zs: 'Nhiệt độ màu chính',
				fl: 'Độ sáng phụ',
				fs: 'Nhiệt độ màu phụ',
				ld: 'Độ sáng liên kết',
				ll: 'Độ sáng liên kết',
				jcqkg1: 'Lộ 1',
				jcqkg2: 'Lộ 2',
				jcqkg3: 'Lộ 3',
				jcqkg4: 'Lộ 4',
				jcqkg5: 'Lộ 5',
				jcqkg6: 'Lộ 6',
				jcqkg7: 'Lộ 7',
				jcqkg8: 'Lộ 8',
			},
			setHlfdtg: {
				lux: 'Ngưỡng độ rọi',
				tgv: 'Độ sáng điều chỉnh',
				switch: 'Công tắc',
				luxMax: 'Lớn hơn ngưỡng độ rọi',
				luxMin: 'Nhỏ hơn ngưỡng độ rọi',
				group: {
					0: 'Đoạn ',
					1: '',
				},
			},
			setWarnsafe: {
				checkdelay: 'Thời gian kiểm tra liên tục (giây)',
				hotup: 'Giới hạn nhiệt độ trên khi sưởi (℃)',
				hotdown: 'Giới hạn nhiệt độ dưới khi sưởi (℃)',
				hotreturn: 'Độ trễ nhiệt độ khi sưởi (℃)',
				enloop: 'Kích hoạt mạch'
			},
			setTgzr: {
				todaySeconds: 'Thời gian',
				tg1: 'Độ sáng Lộ 1',
				tg2: 'Độ sáng Lộ 2',
				tg3: 'Độ sáng Lộ 3',
				tg4: 'Độ sáng Lộ 4',
				tg5: 'Độ sáng Lộ 5',
				tg6: 'Độ sáng Lộ 6',
				tg7: 'Độ sáng Lộ 7',
				tg8: 'Độ sáng Lộ 8'
			},
			setSxjlxs: {
				groupList: {
					0: "Hệ số đo điện áp 3 pha",
					1: "Hệ số đo dòng điện 3 pha",
					2: "Hệ số đo công suất 3 pha",
				},
				labelList: {
					A: 'Pha A:',
					B: 'Pha B:',
					C: 'Pha C:',
				},
				labelList2: {
					A: 'Pha A',
					B: 'Pha B',
					C: 'Pha C',
				},
				singleLamp: {
					vjl: "Điện áp",
					zijl: "Dòng điện đèn chính",
					fijl: "Dòng điện đèn phụ",
					zpjl: "Công suất đèn chính",
					fpjl: "Công suất đèn phụ",
				}
			},
			batchIPP: {
				hs: 'Thời gian heartbeat',
				ip: 'IP',
				port: 'Cổng'
			},
			setLxzq: {
				lxzq: 'Chu kỳ thăm dò (phút)'
			},
			setJzqckg: {
				jzqczkg: 'Công tắc'
			},
			tgByGroup: {
				lightTypeId: 'Loại chiếu sáng'
			},
			setDDQKRBMS: {
				ddqkrbms: 'Chế độ lịch ngày nhóm đèn đơn'
			},
			setTgrbms: {
				tgrbms: 'Chế độ lịch ngày điều chỉnh độ sáng 8 kênh'
			},
			setDDQKGGTG: {
				defaultL: 'Độ sáng mặc định',
				defaultS: 'Nhiệt độ màu mặc định',
				tgStepNum: 'Bước điều chỉnh độ sáng',
				tgMin: 'Độ sáng tối thiểu',
				tgMax: 'Độ sáng tối đa'
			},
			setWSGD: {
				wsgd: 'Cấp nguồn thiết bị ngoại vi'
			},
			setGpnum: {
				lightTypeId: 'Loại chiếu sáng'
			},
			setTM: {
				tm: ''
			},
			setLxkg: {
				lxkg: 'Công tắc thăm dò'
			},
			setWlid: {
				wlId: 'ID mạng'
			},
			setLc: {
				lcs: 'Công tắc quang cảm',
				lcov: 'Giá trị bật đèn theo quang cảm',
				lcrd: 'Giá trị độ trễ tắt đèn',
			},
			fotaCenterLight: {
				subSize: 'Kích thước gói phân đoạn',
				retryNum: 'Số lần thử lại',
				intervalTime: 'Khoảng cách thời gian thử lại (ms)',
				firmwareId: 'Firmware nâng cấp',
				intervalTime: 'Thời gian giãn cách giữa các gói'
			},
			wlsd: {
				port: "Cổng",
				account: "Tài khoản",
				password: "Mật khẩu",
				key: "Khóa xác thực quyền",
			},
			setZjid: {
				zjid: 'ID máy chủ'
			},
			setCjid: {
				cjid: 'ID máy con'
			},
			HKSetConfigId: {
				config: "Tên cấu hình",
			},
			HKChannel: {
				channel: "Số kênh",
			},
			setG: {
				pgn: "Mã nhóm thiết bị đoạn trên",
				tgn: "Mã nhóm thiết bị đoạn này",
				gn: 'Mã nhóm thiết bị'
			},
			setLkg: {
				lkg: 'Công tắc vận hành hệ thống liên kết',
				to: 'Thời gian quá hạn Radar (giây)'
			},
			setRC: {
				ras: 'Điều chỉnh độ nhạy Radar',
				rcd: 'Hướng phát hiện của Radar',
				riar: 'Bù góc lắp đặt Radar',
				rai: 'Điều chỉnh khả năng chống nhiễu Radar',
			},
			setAic: {
				aic: 'Cấu hình chế độ thị giác AI'
			},
			set433: {
				wc433: 'Kênh làm việc',
				pl433: 'Mức công suất',
				wlid433: 'ID mạng',
				ts433: 'Tốc độ truyền',
			},
			setRkg: {
				rkg: "Công tắc vận hành"
			},
			setRTC: {
				rtd1: 'Khoảng cách mục tiêu chuyển động 1 (cm)',
				rts1: 'Độ nhạy mục tiêu chuyển động 1',
				rtd2: 'Khoảng cách mục tiêu chuyển động 2 (cm)',
				rts2: 'Độ nhạy mục tiêu chuyển động 2',
				rtd3: 'Khoảng cách mục tiêu chuyển động 3 (cm)',
				rts3: 'Độ nhạy mục tiêu chuyển động 3',
				std1: 'Khoảng cách mục tiêu tĩnh 1 (cm)',
				sts1: 'Độ nhạy mục tiêu tĩnh 1',
				std2: 'Khoảng cách mục tiêu tĩnh 2 (cm)',
				sts2: 'Độ nhạy mục tiêu tĩnh 2',
				std3: 'Khoảng cách mục tiêu tĩnh 3 (cm)',
				sts3: 'Độ nhạy mục tiêu tĩnh 3',
				dc: "Khả năng phát hiện Radar",
				rai: "Khả năng chống nhiễu Radar",
			},
			setRtp: {
				rtp: "Số chu kỳ duy trì mục tiêu Radar (x0.1 giây)",
			},
			setTo: {
				to: "Thời gian quá hạn Radar (giây)"
			},
			view: {
				tabs: {
					list: 'Danh sách',
					echart: 'Biểu đồ',
					getr: 'Xem lịch ngày',
					view1: 'Thuộc tính thiết bị',
					getJr: 'Xem lịch ngày tính giờ',
					getZr: 'Xem lịch ngày đúng giờ'
				},
				nowTr: 'Lịch ngày hiện chọn:',
				jwdkgt: 'Thời gian bật/tắt đèn theo kinh vĩ độ địa phương:',
				lcs: 'Công tắc quang cảm:',
				lcov: 'Giá trị bật đèn theo quang cảm:',
				lcrd: 'Giá trị độ trễ tắt đèn:',
				open: 'Bật:',
				close: 'Tắt:',
				tgzt: 'Trạng thái điều chỉnh độ sáng hiện tại:',
				getZr: 'Lịch ngày đúng giờ',
				getJr: 'Lịch ngày tính giờ',
				getGP: 'Bảng kinh vĩ độ hàng ngày',
			},
			error: 'Vui lòng chọn thiết bị trước khi thực hiện thao tác',
			json: {
				btnList: {
					Light: {
						jzqzhining: 'Lệnh bộ tập trung',
						kzhl: 'Điều khiển mạch',
						qkdd: 'Nhóm điều khiển đèn đơn',
						rjl: 'Đồng bộ hệ số đo',
						rd: 'Đọc dữ liệu tức thời',
						lightOption: 'Điều chỉnh độ sáng',
						dimLightOption: 'Điều chỉnh độ sáng',
						syncTime: 'Hiệu chỉnh đồng hồ',
						as: 'Đọc thuộc tính thiết bị',
						reb: 'Khởi động lại',
						SIM: 'Đọc SIM thiết bị',
						batchReadIPP: 'Đọc thông số mạng',
						batchIPP: 'Thiết lập thông số mạng',
						setGP: 'Thiết lập kinh vĩ độ',
						setGPR: 'Cài đặt bảng kinh độ/vĩ độ theo ngày',
						syncGPR: 'Đồng bộ bảng kinh độ/vĩ độ theo ngày',
						setLdcs: 'Thông số liên kết',
						skhl: 'Điều khiển mạch thủ công',
						setHlgg: 'Cài đặt cảm biến quang mạch',
						setJwdpyz: 'Cài đặt độ lệch kinh vĩ độ',
						setGJZQ: 'Cài đặt chu kỳ cảnh báo',
						setHgqzsb: 'Cài đặt tỷ số vòng biến dòng',
						setKglsc: 'Cài đặt 3 ngõ ra tín hiệu số',
						setSbsjzq: 'Cài đặt chu kỳ heartbeat',
						setJzqczkg: 'Kích hoạt màn hình bộ tập trung',
						syncRgj: 'Đồng bộ thông số cảnh báo thiết bị',
						syncJwd: 'Đồng bộ thông số kinh vĩ độ địa phương',
						syncRhlgg: 'Đồng bộ thông số cảm biến quang mạch',
						setHlNb: 'Cài đặt lịch năm mạch điện',
						syncHlNb: 'Đồng bộ lịch năm mạch điện',
						setHlRm: 'Chế độ lịch ngày mạch điện',
						setHLZR: 'Cài đặt lịch ngày đúng giờ',
						getHLZR: 'Đồng bộ lịch ngày đúng giờ',
						getSxjlxs: 'Đồng bộ hệ số đo',
						setSxjlxs: 'Cài đặt hệ số đo',
						syncDDZR: 'Đồng bộ lịch ngày đúng giờ nhóm đèn đơn',
						setDDZR: 'Cài đặt lịch ngày đúng giờ nhóm đèn đơn',
						setBmd: 'Cài đặt danh sách trắng (Whitelist)',
						syncBmd: 'Lấy danh sách trắng',
						syncHLZR: 'Đồng bộ lịch ngày đúng giờ mạch',
						syncDDQKGGTG: 'Đồng bộ cài đặt quang cảm nhóm đèn đơn',
						setLxzq: 'Cài đặt chu kỳ thăm dò',
						setJzqckg: 'Kích hoạt màn hình bộ tập trung',
						tgByGroup: 'Điều khiển nhóm đèn thủ công',
						setDDQKRBMS: 'Cài đặt chế độ lịch ngày nhóm đèn đơn',
						setDDQKGGTG: 'Cài đặt cảm biến quang nhóm đèn đơn',
						setWSGD: 'Cài đặt cấp nguồn thiết bị ngoại vi',
						reset: 'Đặt lại thiết bị',
						setGpnum: 'Cài đặt loại chiếu sáng',
						syncGpnum: 'Đồng bộ loại chiếu sáng',
						setTM: 'Hiệu chỉnh đồng hồ',
						readTm: 'Đọc đồng hồ thiết bị',
						setLxkg: 'Cài đặt công tắc thăm dò',
						syncJr: 'Đồng bộ lịch ngày tính giờ',
						syncZr: 'Đồng bộ lịch ngày đúng giờ',
						setVjl: 'Cài đặt hệ số đo điện áp',
						setIjl: 'Cài đặt hệ số đo dòng điện',
						setPjl: 'Cài đặt hệ số đo công suất',
						syncDDQKJR: 'Đồng bộ lịch ngày tính giờ nhóm đèn đơn',
						setDDQKJR: 'Cài đặt lịch ngày tính giờ nhóm đèn đơn',
						setWlid: 'Cài đặt ID mạng',
						syncWlid: 'Đồng bộ ID mạng',
						fotaCenterLight: 'Nâng cấp đèn đơn/kép qua bộ tập trung',
						setDdldggld: 'Cài đặt thông số liên kết Radar - Quang cảm',
						setHlfdtg: 'Cài đặt phân đoạn điều sáng cảm biến quang',
						setWarnsafe: 'Cài đặt bảo vệ cảnh báo mưa tuyết',
						setTgrbms: 'Cài đặt chế độ lịch ngày điều chỉnh độ sáng',
						setTgnb: 'Cài đặt lịch năm điều chỉnh độ sáng',
						setTgzr: 'Cài đặt lịch ngày đúng giờ điều chỉnh độ sáng',
						setTggg: 'Cài đặt điều chỉnh độ sáng theo cảm biến ánh sáng',
						setTgbc: 'Bù sáng tự thích ứng',
						jzqczkg: 'Công tắc thao tác bộ tập trung',
						syncTgnb: 'Đồng bộ lịch năm điều chỉnh độ sáng',
						syncTgzr: 'Đồng bộ lịch ngày đúng giờ điều chỉnh độ sáng',
						syncTggg: 'Đồng bộ thông số điều sáng cảm biến quang',
						async8DV: 'Đồng bộ giá trị điều chỉnh độ sáng 8 kênh',
						async3SI: 'Đồng bộ 3 ngõ vào tín hiệu số',
						async3SO: 'Đồng bộ 3 ngõ ra tín hiệu số',
						clearCache: 'Xóa bộ nhớ đệm lệnh',
						setTglj: 'Cài đặt logic điều chỉnh độ sáng',
						save: 'Công tắc bảo vệ đường dây',
						setTgmrv: 'Cài đặt giá trị điều chỉnh độ sáng mặc định',
						readE: 'Đồng bộ cài đặt cảnh báo',
						readE1: 'Đồng bộ cài đặt cảnh báo mở rộng',
						setRm: 'Cài đặt chế độ lịch ngày',
						readLc: 'Đồng bộ công tắc quang cảm',
						setLc: 'Cài đặt công tắc quang cảm',
						setLcov: 'Lấy mẫu cài đặt giá trị bật đèn',
						wlsd: 'Cấu hình mạng',
						setZjid: 'Cài đặt ID máy chủ',
						setCjid: 'Cài đặt ID máy con',
						excelDownload: 'Xuất file Excel',
						hkSetJwd: 'Sửa kinh vĩ độ',
						HKSetConfigId: 'Sửa cấu hình',
						hksetChannel: 'Cài đặt số kênh',
						setG: 'Cài đặt mã nhóm thiết bị',
						readG: 'Đồng bộ mã nhóm thiết bị',
						setLkg: 'Cài đặt công tắc vận hành hệ thống liên kết',
						readLkg: 'Đồng bộ công tắc vận hành hệ thống liên kết',
						setRC: 'Cài đặt cấu hình Radar',
						readRC: 'Đồng bộ cấu hình Radar',
						setAic: 'Cài đặt cấu hình chế độ thị giác AI',
						readAic: 'Đồng bộ cấu hình chế độ thị giác AI',
						set433: 'Cài đặt mô-đun truyền thông 433',
						read433: 'Đồng bộ mô-đun truyền thông 433',
						readV: 'Đọc thông tin phiên bản thiết bị',
						setRkg: 'Cài đặt công tắc vận hành',
						readRkg: 'Đồng bộ công tắc vận hành',
						setRTC: 'Cài đặt phát hiện mục tiêu Radar',
						readRTC: 'Đồng bộ phát hiện mục tiêu Radar',
						setRtp: 'Cài đặt số chu kỳ duy trì mục tiêu Radar',
						readRtp: 'Đồng bộ số chu kỳ duy trì mục tiêu Radar',
						setTo: 'Cài đặt thời gian quá hạn Radar',
						readTo: 'Đồng bộ thời gian quá hạn Radar',
						option: {
							monitor: "Xem giám sát",
							location: "Xem vị trí định vị",
							channel: "Cài đặt số kênh"
						}
					}
				}
			}
		},
		user: {
			status1: 'Khóa tài khoản',
			status2: 'Kích hoạt',
			status3: 'Bình thường',
			changeAuthority: 'Sửa quyền hạn',
			reset: 'Đổi MK',
			passwordTips: 'Vui lòng nhập mật khẩu của bạn',
			passwordTips2: 'Nhập mật khẩu của bạn',
			drawChangePw: 'Đổi mật khẩu',
			message: 'Chuẩn bị đăng nhập lại',
			passwordRule: 'Vui lòng nhập lại mật khẩu',
			passwordRule2: 'Hai lần nhập mật khẩu không khớp',
			searchPlaceholder: 'Vui lòng nhập biệt danh hệ thống',
			third: {
				name: 'Tên',
				type: 'Loại',
				parameter: 'Tham số',
				updateTime: 'Thời gian cập nhật mới nhất',
				msg: 'Độ dài trong khoảng',
			},
			media: {
				name: "Tên luồng phương tiện",
				type: 'Loại',
				previewImg: 'Ảnh xem trước',
				size: 'Kích thước',
				createTime: 'Thời gian tạo',
			},
			alarm: {
				isAlarm: "Cài đặt tin nhắn SMS cảnh báo",
				sendTime: "Thời gian gửi tin nhắn SMS",
				sendNum: "Số lượng tin nhắn SMS còn lại",
				tip: "Cấu hình thông tin cảnh báo",
			},
			authority: {
				asset: 'Nhóm tài sản',
				device: 'Thiết bị / Tài sản thiết bị',
				controlDevice: 'Thao tác điều khiển thiết bị từ xa',
				createWorkOrder: 'Tạo phiếu công việc',
				receiveWorkOrder: 'Tiếp nhận phiếu công việc',
				strategyRule: 'Quy tắc & Chiến lược',
				log: 'Quyền xem nhật ký',
				group: 'Phân bổ nhóm thiết bị',
			},
			tableColumn: {
				username: 'Tên người dùng',
				nickname: 'Biệt danh hệ thống',
				createTime: 'Ngày tạo',
				appCount: 'Tổng số dự án',
				devicesCount: 'Tổng số thiết bị',
				status: 'Trạng thái',
				appName: 'Tên dự án',
				updateTime: 'Ngày tạo',
				phone: 'Thông tin liên hệ'
			},
			addEditDrawer: {
				function: 'Chức năng',
				authority: 'Quyền hạn',
				readWrite: 'Đọc/Ghi',
				readOnly: 'Chỉ đọc',
				permit: 'Cho phép',
				forbidden: 'Vô hiệu hóa',
				username: 'Tên người dùng:',
				nickname: 'Biệt danh hệ thống:',
				userType: 'Loại người dùng:',
				password: 'Mật khẩu:',
				phoneCountryCode: 'Mã vùng:',
				contactPhone: 'Thông tin liên hệ:',
				devicesCount: 'Tổng số thiết bị:',
				status: 'Trạng thái:',
				rules: {
					username: 'Độ dài từ 3-20 ký tự và không chứa ký tự tiếng Trung',
					nickname: 'Vui lòng nhập biệt danh hệ thống',
					userType: 'Vui lòng chọn loại người dùng',
					password: 'Vui lòng nhập mật khẩu khởi tạo',
					passwordEdit: 'Vui lòng nhập mật khẩu mới',
					phoneCountryCode: 'Vui lòng chọn mã vùng trước',
					contactPhone1: 'Vui lòng nhập số điện thoại di động',
					contactPhone2: 'Định dạng liên hệ không hợp lệ, vui lòng nhập lại',
					contactPhone3: 'Vui lòng chọn mã vùng trước',
					oneMessage: 'Độ dài phải nhỏ hơn 20',
					userNameTwo: 'Độ dài từ 12-30 ký tự và không chứa ký tự tiếng Trung',
					passwordTwo: 'Độ dài từ 8-20 ký tự và phải chứa ít nhất một chữ cái'
				}
			}
		},
		header: {
			oldPassword: 'Mật khẩu cũ',
			newPassword: 'Mật khẩu mới',
			renew: 'Nhập lại mật khẩu',
			oldPasswordRule: 'Vui lòng nhập mật khẩu cũ',
			newPasswordRule: 'Vui lòng nhập mật khẩu mới',
			SecretKey: 'SecretKey:',
			creatTime: 'Thời gian tạo:',
			changeSecretKey: 'Thay đổi SecretKey',
			addSecretKey: 'Thêm mới SecretKey',
			changeSecretKeyTip: 'Bạn có muốn thay đổi SecretKey không? (Thao tác này sẽ làm mất hiệu lực SecretKey cũ và ảnh hưởng đến kết nối API)',
			changeAfterTip: 'Lưu ý: Vui lòng sao chép, lưu trữ và bảo mật SecretKey cẩn thận, bạn sẽ không thể xem lại sau này!',
			copySuc: 'Đã sao chép SecretKey thành công'
		},
		setting: {
			tableColumn: {
				jcqnb: {
					name: 'Tên lịch năm',
					time: 'Khoảng ngày',
					['1_time']: 'Hành động 1',
					['2_time']: 'Hành động 2',
					['3_time']: 'Hành động 3',
					['4_time']: 'Hành động 4',
					text: '*Khi độ sáng là 101, bật chế độ điều chỉnh độ sáng theo cảm biến ánh sáng'
				},
				lightTypeMag: {
					groupNum: 'Mã nhóm',
					id: 'ID loại chiếu sáng',
					lightType: 'Loại chiếu sáng',
					add: 'Thêm loại chiếu sáng mới'
				}
			}
		},
		energy: {
			type: 'Loại',
			mode: "Loại thời gian",
			timeType: "Khung thời gian",
			Chart: "Biểu đồ",
			Table: "Bảng",
		},
		lightRate: {
			hour: 'Thời điểm',
			time: 'Khoảng thời gian',
			tableColumn:{
				onCount: 'Số lượng đèn sáng',
				offCount: 'Số lượng đèn tắt',
				onRate: 'Tỷ lệ đèn sáng',
				offRate: 'Tỷ lệ đèn tắt',
				timeHour: 'Thời gian'
			}
		},
		communication: {
			searchPlaceholder: 'Số thuê bao, ICCID, IMSI',
			btnList: {
				balanceDisplay: 'Hiển thị số dư',
				balanceRecharge: 'Nạp tiền số dư',
				updateData: 'Cập nhật dữ liệu nhà mạng mới',
			},
			title: {
				paymentMethod: 'Phương thức thanh toán',
				wechat: 'WeChat',
				Alipay: 'Alipay',
				totalAmount: 'Tổng số tiền',
				topUp: 'Nạp tiền'
			},
			tableColumn: {
				msisdn: 'Số thuê bao (MSISDN)',
				iccid: 'ICCID',
				imsi: 'IMSI',
				operator: 'Nhà mạng',
				orgName: 'Tên khách hàng',
				dueDate: 'Ngày hết hạn',
				workingCondition: 'Trạng thái thẻ',
				lifeCycle: 'Vòng đời',
				comboNameValue: "Gói cước (MB)",
				chargeGprs: "Lượng sử dụng trước khi nạp (MB)",
				remainGprs: 'Dung lượng còn lại (MB)',
				useGprs: 'Lượng sử dụng trong tháng (MB)',
				totalGprs: 'Tổng dung lượng gói (MB)',
				comboName: 'Gói cước',
				comboType: 'Loại gói cước',
				waitType: 'Loại thời gian chờ',
				waitDate: 'Ngày hết hạn thời gian chờ',
				testType: 'Loại thời gian thử nghiệm',
				testDate: 'Ngày hết hạn thử nghiệm',
				isOrienteer: 'Định hướng (Dedicated)',
				totalVoice: 'Tổng thời lượng thoại (phút)',
				useVoice: 'Thời lượng thoại đã dùng (phút)',
				remainVoice: 'Thời lượng thoại còn lại (phút)',
				customerName: 'Tên khách hàng',
				accountBalance: 'Số dư tài khoản',
			}
		}
	},
	vue3CronEp: {
	  cron: "Biểu thức Cron",
	  second: "Giây",
	  minute: "Phút",
	  hour: "Giờ",
	  day: "Ngày",
	  month: "Tháng",
	  week: "Tuần",
	  year: "Năm",
	  help: "Trợ giúp",
	  every: "Mỗi",
	  startFrom: "Từ",
	  notSpecify: "Không chỉ định",
	  seconds: "giây bắt đầu",
	  everySeconds: "giây sau",
	  minutes: "phút bắt đầu",
	  everyMinutes: "phút sau",
	  hours: "giờ bắt đầu",
	  everyHours: "giờ sau",
	  days: "ngày bắt đầu",
	  everyDays: "ngày sau",
	  months: "tháng bắt đầu",
	  everyMonths: "tháng sau",
	  start: "bắt đầu",
	  everyWeeks: "tuần sau",
	  years: "năm bắt đầu",
	  everyYears: "năm sau",
	  stepEvery: "mỗi",
	  between: "Giữa",
	  to: "và",
	  betweenSecond: "giây",
	  betweenMinute: "phút",
	  betweenHour: "giờ",
	  betweenDay: "ngày",
	  betweenMonth: "tháng",
	  betweenYear: "năm",
	  fixed: "Cố định",
	  confirm: "Đồng ý",
	  cancel: "Hủy",
	  title: "Trình tạo Cron",
	  lastNDays: "Ngày cuối cùng của tháng",
	  lastWeekOfMonth: "Tuần cuối cùng của tháng",
	  nthWeekOfMonth: "Tuần thứ N của tháng",
	  ge: "thứ",
	  notConfig: "Không cấu hình",
	  helpFormat: "Định dạng: Giây Phút Giờ Ngày Tháng Tuần [Năm]",
	  helpAll: "* : Đại diện cho tất cả giá trị",
	  helpNone: "? : Giá trị không xác định, chỉ dùng cho trường Ngày và Tuần",
	  helpMutual: "Loại trừ lẫn nhau: Ngày và Tuần không thể chỉ định cùng lúc, một trong hai phải là ?",
	  helpL: "L : Nghĩa là Cuối cùng; Ngày=ngày cuối cùng của tháng, Tuần=Thứ Bảy",
	  helpHash: "# : Thứ tự ngày trong tuần của tháng, ví dụ 2#2 = Thứ Hai thứ 2 của tháng",
	  helpSlash: "/ : Bước khoảng cách, ví dụ 0/5 = mỗi 5 đơn vị bắt đầu từ 0",
	  helpDash: "- : Khoảng, ví dụ 1-5 = tất cả giá trị từ 1 đến 5",
	  helpComma: ", : Liệt kê, ví dụ 1,3,5 = chỉ thực hiện vào ngày 1,3,5",
	  helpLastDay: "Cách dùng L: Trường Ngày L = ngày cuối cùng của tháng",
	  helpLastWeek: "Cách dùng L: Trường Tuần 2L = Thứ Hai cuối cùng của tháng",
	  reset: "Đặt lại",
	  pleaseSelect: "Vui lòng chọn",
	  presetPlaceholder: "Chọn lịch trình phổ biến",
	  usePreset: "Sử dụng",
	  presets: {
	    dailyMidnight: "Mỗi ngày lúc nửa đêm",
	    dailyNoon: "Mỗi ngày lúc 12:00",
	    everyFiveMinutes: "Mỗi 5 phút",
	    hourly: "Mỗi giờ",
	    workdayHourly: "Mỗi giờ từ 8:00 đến 18:00, Thứ Hai đến Thứ Sáu",
	    weekdayMorning: "Lúc 9:30, Thứ Hai đến Thứ Sáu",
	    monthlyFirstDay: "Lúc nửa đêm ngày đầu tiên của mỗi tháng",
	    monthlyLastDay: "Lúc nửa đêm ngày cuối cùng của mỗi tháng"
	  },
	  weekDays: {
	    1: "Chủ Nhật",
	    2: "Thứ Hai",
	    3: "Thứ Ba",
	    4: "Thứ Tư",
	    5: "Thứ Năm",
	    6: "Thứ Sáu",
	    7: "Thứ Bảy"
	  },
	  validation: {
	    mainInputTip: "Chỉ cho phép số, *, ?, /, -, ,, khoảng trắng, L, #, và SUN/MON/TUE/WED/THU/FRI/SAT",
	    fieldInputTip: "Chỉ cho phép số, *, ?, /, -, ,, L, #, và SUN/MON/TUE/WED/THU/FRI/SAT",
	    invalidCharacters: "Phát hiện ký tự không hợp lệ. Giá trị hợp lệ trước đó đã được khôi phục.",
	    fieldFormat: "Lỗi định dạng [{field}]: {message}",
	    starOrQuestionMustBeAlone: "{field}: * hoặc ? phải được sử dụng riêng lẻ",
	    expressionLength: "Biểu thức phải chứa 6 hoặc 7 trường",
	    dayWeekMutualExclusive: "Ngày và Tuần không thể chỉ định cùng lúc. Một trong hai phải là ?",
	    dayWeekCannotBothEmpty: "Ngày và Tuần không thể cùng là ?",
	    onlyWeekSupportsHash: "Chỉ trường Tuần mới hỗ trợ #",
	    hashFormat: "Định dạng # không hợp lệ. Ví dụ: 7#2",
	    weekRange: "Ngày trong tuần phải từ 1 đến 7",
	    hashOrderRange: "Giá trị thứ tự phải từ 1 đến 5",
	    onlyDaySupportsLastOffset: "Chỉ trường Ngày mới hỗ trợ L-N",
	    lastOffsetFormat: "Định dạng L-N không hợp lệ",
	    lastOffsetRange: "Giá trị L-N phải từ 1 đến 31",
	    weekLastFormat: "Định dạng L của Tuần không hợp lệ. Dùng số + L, ví dụ 2L",
	    stepGreaterThanZero: "Bước phải lớn hơn 0",
	    rangeFormat: "Định dạng khoảng không hợp lệ",
	    rangeStartGreaterThanEnd: "Giá trị bắt đầu không thể lớn hơn giá trị kết thúc",
	    mustBeNumber: "Giá trị phải là số",
	    valueOutOfRange: "Giá trị nằm ngoài khoảng {min}~{max}"
	  }
	}
}